<script lang="ts" setup>
interface CbzLinkItem {
  title: string
  label: string
  url: string
  target: string
}
defineProps<{
  item: CbzLinkItem
}>()
</script>
<template>
  <div class="item">
    <h4>{{ item.title }}</h4>
    <Button secondary slide :to="item.url" :target="item.target">{{ item.label }}</Button>
  </div>
</template>
<style scoped lang="scss">
.item {
  padding: 24px 0;
  @include breakpoint(ts) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4 {
      margin-bottom: 0;
    }
  }
}
</style>
